import { isClientSide } from '~/src/helpers/ssr.helper';

export const getScrollbarWidth = () => {
    if (!isClientSide()) {
        return 0;
    }

    return window.innerWidth - document.documentElement.clientWidth;
};
